import { useContent } from "@/modules/content/use"

// A fragment's text: its linked content's, unless that content is still to be created.
// contentText(contentId) is the content's text, or undefined when there's none to give.
export const fragmentText = (fragment, contentText) => {
  if (!fragment) return ""
  let linked = fragment.contentId && !fragment._createContent ? contentText(fragment.contentId) : undefined
  return linked ?? fragment.text
}

export const useFragment = function () {
  const bp_content = useContent()

  const text = (fragment) => fragmentText(fragment, bp_content.contentText)

  return {
    text,
  }
}
